<ion-content>
  <div class="blur-container"></div>
  <ion-list class="list-view" *ngIf="popoverMenu">
    <ion-item detail="false" lines='none' button *ngFor="let item of popoverMenu.items" (click)="selectType(item.type)">
      <img [src]="'assets/' + item.icon" alt=""/>
      <ion-label>{{ item.title | translate }}</ion-label>
    </ion-item>
  </ion-list>

  <ion-list class="list-view" *ngIf='type==="ChangeStatus"'>
    <ion-item detail="false" lines='none' button (click)='selectType("Yet To Start")'>
      <ion-label>
        {{ 'Yet To Start' | translate }}
      </ion-label>
    </ion-item>
    <ion-item detail="false" button lines='none' (click)='selectType("in-progress")'>
      <ion-label> {{ 'In Progress' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button (click)='selectType("On Hold")'>
      <ion-label> {{ 'On Hold' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button (click)='selectType("Resolved")'>
      <ion-label> {{ 'Resolved' | translate }}</ion-label>
    </ion-item>
  </ion-list>

  <ion-list class="list-view" *ngIf='type==="userConsoleRoleMang"' style="overflow: hidden;border-radius: 0px;">
    <ion-item detail="false" lines='none' button (click)="selectType('assign-user-role')">
      <ion-label class="user-console-roleMang-text"> {{ 'Role Assignments' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" button lines='none' style="border-bottom: none;" (click)="selectType('all-roles')">
      <ion-label class="user-console-roleMang-text"> {{ 'All Roles' | translate }}</ion-label>
    </ion-item>
  </ion-list>

  <!-- don't change -->
  <ion-list class="list-view" *ngIf='type==="user_mang_allRole_More_Icon"'>
    <ion-item detail="false" lines='none' style="border-bottom: none;" button (click)="selectType('allRoles-add-user')"
      [disabled]="!isRoleWritePermission" [ngClass]="!isRoleWritePermission ? 'disabled-text' : '' ">
      <img src="../../../assets/icon/Add User.svg" alt=""/>
      <ion-label class="user-console-roleMang-text"> {{ 'Add Members' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" button lines='none' style="border-bottom: none;" (click)="selectType('allRoles-edit-role')"
      [disabled]="!isRoleWritePermission" [ngClass]="!isRoleWritePermission ? 'disabled-text' : '' ">
      <img src="../../../assets/icon/edit1.svg" alt=""/>
      <ion-label class="user-console-roleMang-text"> {{ 'Rename Role' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" button lines='none' style="border-bottom: none;" (click)="selectType('allRoles-delete-role')"
      [disabled]="!isRoleDeletePermission" [ngClass]="!isRoleDeletePermission ? 'disabled-text' : '' ">
      <img src="../../../assets/icon/Delete1.svg" alt=""/>
      <ion-label class="user-console-roleMang-text"> {{ 'Delete Role' | translate }}</ion-label>
    </ion-item>
  </ion-list>
  <!-- don't change -->
  <ion-list class="list-view" *ngIf='type==="user_mang_groupMang_More_Icon"'
    style="overflow: hidden;border-radius: 0px;">
    <ion-item detail="false" lines='none' button (click)="selectType('groupMang-add-user')" [disabled]="!isGroupWritePermission"
      [ngClass]="!isGroupWritePermission ? 'disabled-text' : '' ">
      <img src="../../../assets/icon/Add User.svg" alt=""/>
      <ion-label class="user-console-roleMang-text"> {{ 'Add Members' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" button lines='none' style="border-bottom: none;" (click)="selectType('groupMang-edit-group')"
      [disabled]="!isGroupWritePermission" [ngClass]="!isGroupWritePermission ? 'disabled-text' : '' ">
      <img src="../../../assets/icon/edit1.svg" alt=""/>
      <ion-label class="user-console-roleMang-text"> {{ 'Rename Group' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" button lines='none' style="border-bottom: none;" (click)="selectType('groupMang-delete-group')"
      [disabled]="!isGroupDeletePermission || !isGlobalAdminRole" [ngClass]="(!isGroupDeletePermission || !isGlobalAdminRole) ? 'disabled-text' : '' ">
      <img src="../../../assets/icon/Delete1.svg" alt=""/>
      <ion-label class="user-console-roleMang-text"> {{ 'Delete Group' | translate }}</ion-label>
    </ion-item>
  </ion-list>
  <!-- don't change -->
  <ion-list id="machine-bucket-popover-list" (keydown)="onPopoverKeydown($event)" class="list-view" *ngIf='type==="machineSegmentBuckesEditOrCreate"'
    style="overflow: hidden;border-radius: 0px;">
    <ion-item detail="false" lines='none' button (click)="myMachinesSegmentAddBucketButton('create')"
      [disabled]="!isCreateBucketPermission" [ngClass]="!isCreateBucketPermission ? 'disabled-text' : '' ">
      <img src="../../../assets/icon/add_user.svg" alt=""/>
      <ion-label class="user-console-roleMang-text"> {{ 'Create New Bucket' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" button lines='none' style="border-bottom: none;" (click)="myMachinesSegmentAddBucketButton('edit')"
      [disabled]="!isDeleteBucketPermission && !isUpdateBucketPermission"
      [ngClass]="!isUpdateBucketPermission && !isDeleteBucketPermission  ? 'disabled-text' : '' ">
      <img src="../../../assets/icon/edit1.svg" alt=""/>
      <ion-label class="user-console-roleMang-text"> {{ 'Edit/Delete Buckets' | translate }}</ion-label>
    </ion-item>
  </ion-list>
  <!-- don't change -->
  <ion-list id="machine-more-popover-list" (keydown)="onPopoverKeydown($event)" class="list-view"
    *ngIf="type === 'machine-specific-kebab-elipse' ||  type === 'bucket-machine-specific-kebab-elipse'"
    style="overflow: hidden;border-radius: 0px;">
    <ion-item detail="false" button lines='none' (click)="myMachinesSegmentAddBucketButton('edit-machine')"
      *ngIf='type==="machine-specific-kebab-elipse"'>
      <img src="../../../assets/icon/edit1.svg" alt=""/>
      <ion-label class="user-console-roleMang-text">{{ 'Add Estimated Hours' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" button lines='none' (click)="myMachinesSegmentAddBucketButton('clone-machine')">
    <img src="../../../assets/icon/copy.svg" alt=""/>
      <ion-label class="user-console-roleMang-text">{{ 'clone_machine' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" button lines='none' (click)="myMachinesSegmentAddBucketButton('delete-Bucket')"
      *ngIf='type==="bucket-machine-specific-kebab-elipse"'>
      <img src="../../../assets/images/Approve.svg" alt=""/>
      <ion-label class="user-console-roleMang-text"> {{ 'Remove machine from this bucket' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' style="border-bottom: none;" button (click)='selectType("request-4-eye-quality-check")'
      *ngIf="!isFourEyeRequested" [disabled]="!is_RA_Status || !isFourEyeQualityCheckPermission">
      <img src='../../../assets/images/4_eye_quality_check.svg' alt=""/>
      <ion-label> {{ 'Request 4 eyes Quality check' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' style="border-bottom: none;" button (click)='selectType("perform-4-eye-quality-check")'
      *ngIf="isFourEyeQualityPerform"
      [disabled]="!is_RA_Status || !isFourEyeQualityCheckPermission"><!--|| !isFourEyeQualityPerform -->
      <img src='../../../assets/images/4_eye_quality_check.svg' alt=""/>
      <ion-label> {{ 'Perform 4 Eyes Quality Check' | translate }} </ion-label>
    </ion-item>
  </ion-list>

  <ion-list id="machine-management-more-popover-list" (keydown)="onPopoverKeydown($event)" class="list-view"
    *ngIf="type === 'machine-management-kebab-elipse'" style="overflow: hidden;border-radius: 0px;">
    <ion-item detail="false" button lines='none' (click)="myMachinesSegmentAddBucketButton('clone-machine')">
      <img src="../../../assets/icon/copy.svg" alt=""/>
      <ion-label class="user-console-roleMang-text">{{ 'clone_machine' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" button lines='none' style="border-bottom: none;" (click)="myMachinesSegmentAddBucketButton('delete-machine')">
      <img src="../../../assets/icon/Delete1.svg" alt=""/>
      <ion-label class="user-console-roleMang-text">{{ 'Delete Machine' | translate }}</ion-label>
    </ion-item>
  </ion-list>

  <ion-list class="list-view" *ngIf='type==="addMachine"'>
    <ion-item detail="false" lines='none' button (click)='selectType("add-new-machine")'>
      <ion-icon slot=start style="font-size: 16px ;" name='add-circle-outline'></ion-icon>
      <ion-label style="font-size: 7.9px ;">
        {{ 'Add New Machine' | translate}}
      </ion-label>
    </ion-item>
    <ion-item detail="false" button lines='none' (click)='selectType("add-from-library")'>
      <ion-icon slot=start style="font-size: 16px ;" name='add-circle-outline'></ion-icon>
      <ion-label style="font-size: 7.9px ;"> {{ 'Add From Library' | translate}}</ion-label>
    </ion-item>
  </ion-list>
  <!-- don't change -->
  <ion-list class="list-view" *ngIf='type === "4_eyeQualityCheck"'>
    <ion-item detail="false" lines='none' button (click)='selectType("request-4-eye-quality-check")'
      *ngIf="!sharedValue.isFourEyeQualityCheckRequested">
      <img src='../../../assets/images/4_eye_quality_check.svg' alt=""/>
      <ion-label> {{ 'Request 4 eyes Quality check' | translate}}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button (click)='selectType("perform-4-eye-quality-check")'
      *ngIf="sharedValue.isFourEyeQualityCheckRequested">
      <img src='../../../assets/images/4_eye_quality_check.svg' alt=""/>
      <ion-label> {{ 'Perform 4 Eyes Quality Check' | translate}}</ion-label>
    </ion-item>
  </ion-list>
  <!-- don't change -->
  <ion-list class="list-view" *ngIf='type==="listOfServiceMoreIcon"'>
    <ion-item detail="false" lines='none' button
      [hidden]="each_service?.pageName==='createOffer' || this.each_service?.pageName === 'ProjectAction' ||this.each_service?.pageName === 'viewOpp'"
      (click)='listOfServiceMore("edit-service")'>
      <ion-label>
        {{ 'Edit Service' | translate}}
      </ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button (click)='listOfServiceMore("delete-service")'>
      <ion-label> {{ 'Delete Service' | translate}} </ion-label>
    </ion-item>
  </ion-list>

  <ion-list class="list-view" *ngIf='type==="viewOfferMore"'>
    <ion-item detail="false" lines='none' button (click)='selectOffer("edit-Offer")'
      [disabled]="!isDisableEditOfferButton &&!isEditOfferCheckPermission"
      [ngClass]="!isDisableEditOfferButton ? 'disabled-text' : '' ">
      <ion-label>
        {{ 'Edit Offer' | translate}}
      </ion-label>
    </ion-item>
  </ion-list>

  <!-- don't change -->
  <ion-list class="list-view" *ngIf='type==="offerMngTrckr"'>
    <ion-item detail="false" lines='none' button [disabled]='offerDetail.status==="Approved"' (click)='selectOfferType("Assign To")'>
      <ion-label>
        {{ 'Assign To' | translate}}
      </ion-label>
    </ion-item>

    <ion-item detail="false" lines='none' button (click)='selectOfferType("Review Offer")'>
      <ion-label>
        {{ 'View Offer' | translate}}
      </ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button (click)='selectOfferType("Edit Offer")'>
      <ion-label> {{ 'Edit Offer' | translate}}</ion-label>
    </ion-item>
  </ion-list>

  <ion-list id="project-status-popover-list" class="list-view" *ngIf='type==="projectInformationStatus"' (keydown)="onPopoverKeydown($event)">
    <ion-item detail="false" style="cursor: pointer;" lines='none' button (click)='selectOption("editProj")'
      [disabled]="!isEditProjectCheckPermission || shouldDisableEditProjectButton "
      [ngClass]="shouldDisableEditProjectButton ? 'disabled-text' : '' ">
      <img src='../../../assets/icon/edit1.svg' [ngClass]="shouldDisableEditProjectButton ? 'disabled-text' : '' " alt=""/>
      <ion-label>
        {{ 'Edit Project' | translate }}
      </ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button (click)='selectOption("deleteProj")' [disabled]="!shouldDisableDeleteProjectButton"
      [ngClass]="!shouldDisableDeleteProjectButton ? 'disabled-text' : '' ">
      <img src='../../../assets/icon/Delete1.svg' alt=""
        [ngClass]="!shouldDisableDeleteProjectButton ? 'disabled-text' : '' " />
      <ion-label>{{ 'Delete Project' | translate}}</ion-label>
    </ion-item>
    <ion-item detail="false" style="cursor: pointer;" lines='none' (click)='selectOption("blockProj")'
      *ngIf="projectStatus !== 'block' && projectStatus !== 'blocked'" [disabled]="!shouldDisableDeleteProjectButton">
      <img src='../../../assets/icon/Block Project1.svg' alt=""/>
      <ion-label>{{ 'Block Project' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" style="cursor: pointer;" lines='none' (click)='selectOption("releaseProj")'
      *ngIf="projectStatus === 'block' || projectStatus === 'blocked'">
      <img src='../../../assets/icon/Block Project1.svg' alt=""/>
      <ion-label>{{ 'release' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button (click)='selectOption("closeProj")' [disabled]="!shouldDisableDeleteProjectButton">
      <img src='../../../assets/icon/Close Project.svg' alt=""/>
      <ion-label>{{ 'Close Project' | translate }}</ion-label>
    </ion-item>
  </ion-list>

  <ion-list class="list-view" *ngIf='type==="share"'>
    <ion-item detail="false" lines='none' button (click)='selectType("shareoutLook")'>
      <img src='../../../assets/icon/outlook.svg' alt=""/>
      <ion-label> {{ 'Share Via Outlook' | translate}}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button (click)='selectType("shareTeams")'>
      <img src='../../../assets/icon/teams.svg' alt=""/>
      <ion-label> {{ 'Share Via Teams' | translate}}</ion-label>
    </ion-item>
  </ion-list>

  <ion-list class="list-view" *ngIf='type==="openSort"'>
    <ion-item detail="false" lines='none' button>
      <img src='../../../assets/icon/refresh.svg' alt=""/>
      <ion-label>
        {{ 'Date Added' | translate}}
      </ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button>
      <img src='../../../assets/icon/copy.svg' alt=""/>
      <ion-label> {{ 'Publication Date' | translate}}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button>
      <img src='../../../assets/icon/Add.svg' alt=""/>
      <ion-label> {{ 'Last week' | translate}}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button>
      <img src='../../../assets/icon/documents.svg' alt=""/>
      <ion-label> {{ 'Last Month' | translate}}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button>
      <img src='../../../assets/icon/upload.svg' alt=""/>
      <ion-label> {{ 'Custom Range' | translate}}</ion-label>
    </ion-item>
  </ion-list>

  <ion-list class="list-view" *ngIf='type==="openFilter"'>
    <ion-item detail="false" lines='none' button>
      <img src='../../../assets/icon/refresh.svg' alt=""/>
      <ion-label>
        {{ 'Showall' | translate}}
      </ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button>
      <img src='../../../assets/icon/copy.svg' alt=""/>
      <ion-label> {{ 'Microsoft Word' | translate}}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button>
      <img src='../../../assets/icon/Add.svg' alt=""/>
      <ion-label> {{ 'Microsoft Excel' | translate}}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button>
      <img src='../../../assets/icon/documents.svg' alt=""/>
      <ion-label> {{ 'Autocad DWG' | translate}}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button>
      <img src='../../../assets/icon/upload.svg' alt=""/>
      <ion-label> {{ 'Adobe PDF' | translate}}</ion-label>
    </ion-item>
  </ion-list>


  <ion-list id="project-action-popover-list" (keydown)="onPopoverKeydown($event)" class="list-view" *ngIf='type==="openProAction"'>
    <ion-item detail="false" *ngIf="isFromSAP" lines='none' button (click)="redirectOffer()" [disabled]="shouldDisableCreateOffer"
      [ngClass]="shouldDisableCreateOffer ? 'disabled-text' : '' ">
      <img src='../../../assets/icon/add_user.svg' alt=""/>
      <ion-label>
        {{ 'Create Offer' | translate}}
      </ion-label>
    </ion-item>
    <ion-item detail="false" *ngIf="!isFromSAP" lines='none' button (click)="redirectService()">
      <img src='../../../assets/icon/add_user.svg' alt=""/>
      <ion-label>
        {{ 'Create Service' | translate}}
      </ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button (click)="redirectProjectHistory()">
      <img src='../../../assets/icon/history.svg' alt=""/>
      <ion-label>
        {{ 'View Project History' | translate}}
      </ion-label>
    </ion-item>
  </ion-list>

  <ion-list (keydown)="onProfileMenuKeydown($event)" class="list-view1"  *ngIf='type==="openChangeLan"'>
    <div class="profile-container">
      
        <img [src]="userInfo?.thumbnailUrl === '' || userInfo?.thumbnailUrl === null ? '../../../assets/Profile_Potrait.svg' : userInfo.thumbnailUrl" 
            alt="User Image" 
            class="image-avatar" />
      

      <div class="profile-details">
        <div class="profile-name">{{ userInfo?.name }}</div>
        <div class="profile-email">{{ userInfo?.email }}</div>
      </div>
    </div>
    

    <ion-item  button tabindex="0" detail="false" lines='none' class="profile-item" [ngClass]="userInfo?.roles.includes('Global Admin') ? 'pointer-cursor' : ''" (click)="goToUserProfile()">
      <ion-icon name="person-circle-outline"></ion-icon>
      <ion-label>
        <div class="role-container">
          <span class="left-label">{{'Profile'|translate}}</span>          
        </div>
      </ion-label>
    </ion-item>

    <ion-item  tabindex="0" detail="false" lines='none' button class="profile-item" (click)="openUserGuide()">
      <!-- <img class="video-icon" src='assets/icon/video-icon.svg' alt=""/> -->
      <ion-icon name="film-outline"></ion-icon>
      <ion-label class="left-label">{{ 'PRODUCT_GUIDE' | translate}}</ion-label>
    </ion-item>
    <ion-item  tabindex="0" detail="false" lines='none' button class="profile-item last-profile-item" (click)="logOutModalConfirmation()">
      <!-- <img style="width: 8% !important;" src='../../../assets/icon/exit.png' alt=""/> -->
      <ion-icon name="log-out-outline"></ion-icon>
      <ion-label class="left-label"> {{ 'Logout' | translate}}</ion-label>
    </ion-item>
  </ion-list>

  <ion-list class="list-view" *ngIf='type==="conflict_resolution_filter"'>
    <ion-item detail="false" lines='none' button (click)='selectType("sort_by_name")'>
      <ion-label>
        {{ 'Sort by name' | translate}}
      </ion-label>
    </ion-item>
    <ion-item detail="false" button lines='none' (click)='selectType("sort_by_hrn")'>
      <ion-label>{{ 'Sort by HRN Value' | translate}}</ion-label>
    </ion-item>
  </ion-list>

  <ion-list class="list-view" *ngIf='type==="configure-roadmap"'>
    <ion-item detail="false" lines='none' button (click)='selectType("custom_roadmap")'>
      <ion-label>
        {{ 'New...' | translate}}
      </ion-label><!--Create Custom Roadmaps-->
    </ion-item>
    <ion-item detail="false" button lines='none' (click)='selectType("predefined_roadmap")'>
      <ion-label> {{ 'From Template...' | translate}}</ion-label>
    </ion-item>

    <!-- <ion-item button lines='none' (click)='selectType("predefined_roadmap")'>
    <ion-label> {{ 'From Project' | translate}}</ion-label>
  </ion-item> -->
  </ion-list>

  <ion-list class="list-view" *ngIf='type==="save_to_template"'>
    <ion-item detail="false" lines='none' button (click)='selectType("save_to_template")'>
      <ion-label>
        {{ 'Save To Template' | translate}}
      </ion-label><!--Create Custom Roadmaps-->
    </ion-item>
  </ion-list>

  <ion-list id="project-report-popover-list" (keydown)="onPopoverKeydown($event)" class=" list-view" *ngIf='type==="openProReport"'>
    <ion-item detail="false" [disabled]='this.generateProjectDisable' lines='none' button
      (click)="viewReport('Generate Project Report')">
      <img src='../../../assets/icon/refresh.svg' alt=""/>
      <ion-label>{{'Generate RA Report' | translate }}
      </ion-label>
    </ion-item>
    <ion-item detail="false" [disabled]='this.generateProjectDisable' lines='none' button (click)="viewReport('Export To Excel')">
      <img src='../../../assets/images/Excel.png' alt=""/>
      <ion-label>{{'Export to Excel' | translate }}
      </ion-label>
    </ion-item>
    <ion-item detail="false" [disabled]='this.generateProjectDisable' lines='none' button (click)="viewReport('View RA Reports')">
      <img src='../../../assets/icon/documents.svg' alt=""/>
      <ion-label>{{'View RA Reports' | translate }}
      </ion-label>
    </ion-item>
  </ion-list>

  <ion-list class="list-view" *ngIf='type==="user_mangament"'>
    <ion-item detail="false" lines='none' button (click)='selectType("addSalseOrg")'>
      <ion-label> {{'Add' | translate }} {{ 'Sales_Organisation' | translate}}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button (click)='selectType("deleteUser")'>
      <ion-label> {{ 'Delete user' | translate}}</ion-label>
    </ion-item>
  </ion-list>
  <ion-list class=" list-view" *ngIf='type==="roadmapHistory" && this.roadmapHistory?.length'>
    <ion-item detail="false" lines='none' button (click)="changeRoadmapVersion(history)" *ngFor="let history of this.roadmapHistory">
      <div class="item-container">
        <div class="left-content">
          <ion-label>{{history?.roadmapName }} {{history?.version }}
          </ion-label>
        </div>
        <div class="right-content">
          <ion-label>{{history?.modifiedBy }}
          </ion-label>
          <p>{{history?.modifiedAt }}
          </p>
        </div>
      </div>
    </ion-item>
  </ion-list>
  <ion-list id="roadmap-kebab-popover-list" (keydown)="onPopoverKeydown($event)" class=" list-view" *ngIf='type==="section-kebab" || type==="subsection-kebab" || type==="step-kebab"'>
    <ion-item detail="false" lines='none' *ngIf="type==='section-kebab'" button (click)='renameSection(type, "rename")'>
      <ion-label> {{'Rename Section' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' *ngIf="!fromLibrary" [disabled]='type==="section-kebab" ? roadmapViewData?.isMarkedNotApplicable : type==="subsection-kebab" ? roadmapViewData?.isMarkAsNotApplicable : roadmapViewData?.answer == 3' button (click)='markNotApplicable(type, "markNotApplicable")'>
      <ion-label> {{'Mark as Not Applicable' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" *ngIf="!(type === 'step-kebab')" lines='none' button (click)='duplicateEntity(type, "duplicate")'>
      <ion-label *ngIf="type === 'section-kebab'"> {{'Duplicate Section' | translate }}</ion-label>
      <ion-label *ngIf="type === 'subsection-kebab'"> {{'Duplicate Subsection' | translate }}</ion-label>
    </ion-item>
    <ion-item detail="false" lines='none' button (click)='roadmapviewDeleteAction(type, "delete")'>
      <ion-label> {{ 'Delete' | translate}}</ion-label>
    </ion-item>
  </ion-list>
</ion-content>